import React from 'react';
import { Link } from 'react-router-dom';
import { cx, css } from '@emotion/css';

const cardStyles = css`
  display: block;
  position: relative;
  width: 100%;
  height: 400px;
  border-radius: 28px;
  overflow: hidden;
  text-decoration: none;
  box-shadow: 0px 10px 30px rgba(241, 102, 2, 0.05);
  border: 1.5px solid rgba(241, 102, 2, 0.18);
  background: linear-gradient(to bottom, #fffcf9 0%, #fff3e6 65%, #ffe6cc 100%);
  transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 25px 50px rgba(241, 102, 2, 0.15), 0 0 35px rgba(241, 102, 2, 0.08);
    text-decoration: none;
    border-color: rgba(241, 102, 2, 0.45);
    background: linear-gradient(to bottom, #fffcf9 0%, #fff0e0 55%, #ffd4a8 100%);

    .card-logo-container {
      border-color: #f16602;
      box-shadow: 0 15px 40px rgba(241, 102, 2, 0.2);
      transform: scale(1.05);
      
      img {
        transform: scale(1.1);
      }
    }

    .logo-glow {
      transform: scale(1.2);
      opacity: 0.8;
    }
  }

  .card-logo-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1.5rem;
    margin-bottom: 0.8rem;
    position: relative;
  }

  .card-logo-container {
    width: 140px;
    height: 140px;
    border-radius: 32px;
    overflow: hidden;
    background: #ffffff;
    border: 2px solid rgba(241, 102, 2, 0.18);
    box-shadow: 0 10px 35px rgba(241, 102, 2, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
    z-index: 2;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 12px;
      transition: transform 0.6s cubic-bezier(0.25, 1, 0.5, 1);
    }
  }

  .logo-glow {
    position: absolute;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(241, 102, 2, 0.15) 0%, transparent 70%);
    filter: blur(8px);
    z-index: 1;
    pointer-events: none;
    transition: all 0.4s ease;
  }

  .card-icon-container {
    position: absolute;
    top: 1.2rem;
    left: 1.2rem;
    z-index: 3;
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(16px);
    border: 1px solid rgba(241, 102, 2, 0.18);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .card-badge-container {
    position: absolute;
    top: 1.2rem;
    right: 1.2rem;
    z-index: 3;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(16px);
    border: 1px solid rgba(241, 102, 2, 0.18);
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 0.68rem;
    font-weight: 700;
    color: #f16602;
    letter-spacing: 0.02em;
    display: flex;
    align-items: center;
    gap: 6px;

    .badge-dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #f16602;
      box-shadow: 0 0 8px #f16602;
    }
  }

  .card-content-area {
    padding: 0 2rem 1.5rem 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .card-subtitle {
    font-size: 0.68rem;
    font-weight: 700;
    color: #f16602;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    margin-bottom: 0.4rem;
  }

  .card-title {
    font-size: 1.55rem;
    font-weight: 800;
    color: #382110;
    text-transform: uppercase;
    letter-spacing: -0.01em;
    margin: 0 0 0.5rem 0;
    line-height: 1.25;
  }

  .info-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.4rem;
    padding: 0;
    margin: 0 0 0.8rem 0;
    list-style: none;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.84rem;
    color: #594436;
    font-weight: 600;
  }

  .info-icon {
    font-size: 0.95rem;
    color: #f16602;
  }

  .btn-primary {
    cursor: pointer;
    padding: 0.8rem;
    width: 100%;
    background: #f16602;
    font-size: 0.8rem;
    font-weight: 700;
    color: #ffffff;
    border: 0;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-radius: 9999px;
    box-shadow: 0 4px 15px rgba(241, 102, 2, 0.25);
    transition: all 0.3s ease;
    text-align: center;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(241, 102, 2, 0.35);
    }
  }
`;

function CourseNewCard(props) {
  const { title, imgsrc, levels, totalquestions, event, category } = props;

  return (
    <Link 
      to={{ pathname: "/coursequiz", state: event }}
      className={cx(cardStyles)}
    >
      {/* Top Left Floating Category Icon */}
      <div className="card-icon-container">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '20px', height: '20px', color: '#f16602' }}>
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        </svg>
      </div>

      <div className="card-badge-container">
        <span className="badge-dot" />
        <span>ACTIVE</span>
      </div>

      {/* Center Logo Container with glow */}
      <div className="card-logo-wrapper">
        <div className="card-logo-container">
          <img src={imgsrc} alt={title} />
        </div>
        <div className="logo-glow" />
      </div>

      <div className="card-content-area">
        <div className="card-subtitle">{category || 'ACADEMIC COURSE'}</div>
        <h3 className="card-title">{title}</h3>

        <ul className="info-list">
          <li className="info-item">
            <span className="info-icon">📚</span>
            <span>{totalquestions} Questions</span>
          </li>
          <li className="info-item">
            <span className="info-icon">🎓</span>
            <span>Levels: {levels ? levels.join(', ') : 'N/A'}</span>
          </li>
          <li className="info-item">
            <span className="info-icon">🏆</span>
            <span>Master Curriculum</span>
          </li>
        </ul>

        <div className="btn-primary">Start Learning</div>
      </div>
    </Link>
  );
}

export default CourseNewCard;
